export const ENVIO_CONTABILIDADE_PERIODOS = Object.freeze({
  MES_ANTERIOR: "mes_anterior",
  MES_ATUAL: "mes_atual",
});

export const ENVIO_CONTABILIDADE_PERIODO_LABELS = Object.freeze({
  mes_anterior: "Mês anterior",
  mes_atual: "Mês atual",
});

export const ENVIO_CONTABILIDADE_TIPO_EXECUCAO_LABELS = Object.freeze({
  automatico: "Execução automática",
  manual: "Execução manual",
  teste: "Envio de teste",
  reenvio: "Reenvio",
});

export const ENVIO_CONTABILIDADE_STATUS_LABELS = Object.freeze({
  pendente: "Pendente",
  gerando: "Gerando",
  gerado: "Gerado",
  enviando: "Enviando",
  enviado: "Enviado",
  parcial: "Parcial",
  falhou: "Falhou",
  cancelado: "Cancelado",
});

export const ENVIO_CONTABILIDADE_STATUS_VARIANTS = Object.freeze({
  pendente: "secondary",
  gerando: "info",
  gerado: "primary",
  enviando: "info",
  enviado: "success",
  parcial: "warning",
  falhou: "danger",
  cancelado: "dark",
});

export const ENVIO_CONTABILIDADE_ARQUIVO_STATUS_LABELS = Object.freeze({
  gerado: "Gerado",
  nao_encontrado: "Não encontrado",
  falhou: "Falhou",
  ignorado: "Ignorado",
});

export const ENVIO_CONTABILIDADE_EMAIL_LOG_STATUS_LABELS = Object.freeze({
  pendente: "Pendente",
  enviado: "Enviado",
  falhou: "Falhou",
});

export const ENVIO_CONTABILIDADE_ITEM_LABELS = Object.freeze({
  xml_nfe: "NF-e autorizadas (XML)",
  xml_nfce: "NFC-e autorizadas (XML)",
  xml_canceladas: "Notas canceladas (XML)",
  xml_inutilizadas: "Inutilizações (XML)",
  xml_cce: "Cartas de correção (XML)",
  danfe_pdf: "DANFE/DANFCE em PDF",
  pedidos_venda: "Pedidos de venda",
  relatorio_faturamento: "Relatório de faturamento",
  relatorio_vendas: "Relatório de vendas",
  relatorio_monofasicos: "Relatório de monofásicos PIS/COFINS",
  sped_fiscal: "SPED Fiscal",
  efd_contribuicoes: "EFD Contribuições",
  sintegra: "Sintegra",
});

export const ENVIO_CONTABILIDADE_DEFAULT_FORM = Object.freeze({
  nome: "",
  ativo: true,
  emails: [],
  cc: [],
  bcc: [],
  dia_mes: 5,
  horario: "07:00",
  timezone: "America/Sao_Paulo",
  periodo: ENVIO_CONTABILIDADE_PERIODOS.MES_ANTERIOR,
  itens: {},
  enviar_sem_movimento: true,
  assunto_email: "",
  mensagem_email: "",
});
